module.exports = __webpack_public_path__ + "static/media/infiniti-bumper_selected.ba194403.svg";